var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C4 1.55 3.55 2 3 2H2V14H3C3.55 14 4 14.45 4 15C4 15.55 3.55 16 3 16H1C0.45 16 0 15.55 0 15V1C0 0.45 0.45 0 1 0H3C3.55 0 4 0.45 4 1ZM12.4429 3.1818C12.8939 2.8628 13.5179 2.9728 13.8359 3.4248L16.8179 7.4248C17.0679 7.7788 17.0599 8.2538 16.7999 8.5998L13.7999 12.5998C13.6039 12.8618 13.3029 12.9998 12.9989 12.9998C12.7909 12.9998 12.5799 12.9348 12.3999 12.7998C11.9579 12.4688 11.8689 11.8418 12.1999 11.4008L13.9999 8.9998H5.9999C5.4479 8.9998 4.9999 8.5528 4.9999 7.9998C4.9999 7.4468 5.4479 6.9998 5.9999 6.9998H13.9999C14.0164 6.9998 14.0317 7.00436 14.0472 7.00895C14.0598 7.01269 14.0724 7.01645 14.0859 7.0178L12.1999 4.5748C11.8819 4.1238 11.9909 3.4998 12.4429 3.1818Z",
    fill: "#F0675B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2af0f9d7.svg";
export { ForwardRef as ReactComponent };